import { Colors } from '@ab-core/colors';
import { RADIUS } from '@ab-core/radius';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const QuantityPickerWrapper = styled.div`
    &.ab-show-picker-calculator {
        grid-template-columns: 1fr auto;
    }
    &.ab-show-picker-cablesnap {
        grid-template-columns: 1fr auto;
    }
    &.ab-show-picker-calculator.ab-show-picker-cablesnap {
        grid-template-columns: 1fr auto auto;
    }

    display: grid;

    gap: ${SPACING.SMALL_3};
`;

export const IconWrapper = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    border: 1px solid ${Colors.gray70};
    box-sizing: border-box;
    height: 40px;
    width: 40px;
    min-width: 40px;
    border-radius: ${RADIUS.MINIMAL};
    align-items: center;
    margin: auto;

    &:hover {
        background-color: ${Colors.backgroundShade};
    }
`;
